<template>
  <div>
    <v-btn
      :loading="loading"
      :disabled="!canExec"
      color="primary"
      @click.prevent="$emit('clickExec')"
    >
      {{ execText }}
    </v-btn>
    <v-btn
      :disabled="loading"
      color="primary"
      @click.prevent="$emit('clickCancel')"
    >
      {{ cancelText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    canExec: {
      type: Boolean,
      default: true,
    },
    execText: {
      type: String,
      default: '登録',
    },
    cancelText: {
      type: String,
      default: 'キャンセル',
    },
  },
}
</script>

<style scoped>
.v-btn {
  min-width: 108px;
}
</style>
